export default __webpack_public_path__ + "static/media/Letters1_10.0dc97ff6.png";